// eslint-disable-next-line import/prefer-default-export
/**
 * Bankruptcy document types that make the API create a compliance system note.
 * Mirrors Constants::BANKRUPTCY_NOTE_DOCUMENT_TYPE_TAGS in lox_api — a type added there
 * must be added here too, or its note is written with a blank case number and date.
 *
 * Consumed by the Bankruptcy quick action and the document subpanel, which both collect
 * the LOX Resolve case number and document date these notes render.
 */
export const NOTE_BEARING_BK_DOCUMENT_TYPES = [
  'document_type_bankruptcy_case',
  'document_type_bankruptcy_confirmation',
  'document_type_bankruptcy_discharge',
  'document_type_bankruptcy_dismissal',
  'document_type_bankruptcy_general_notices',
  'document_type_bankruptcy_notice',
  'document_type_bankruptcy_proof_of_claim',
  'document_type_bankruptcy_settlement_agreement',
  'document_type_bankruptcy_trustee_final',
  'document_type_bankruptcy_modify_plan',
  'document_type_bankruptcy_plan',
]
